module.exports = __webpack_public_path__ + "img/purchased.27f2680b.svg";